export interface ProductForAlternatives {
  atcvetCodes: string[]
  admissionSpecies: string[]
  dosageForms: string[]
}

export interface MatchingCriteriaTranslation {
  key: string
  params: Record<string, string | string[]>
}

export const useProductAlternativesHelper = () => {
  const { t } = useI18n()

  const getMatchingCriteriaTranslation = (matchingCriteria: string, product: ProductForAlternatives | null): string => {
    if (!product) return matchingCriteria

    const atcvetcode = product.atcvetCodes?.join(', ') || ''
    // removed 2 chars from atcvetcode
    const atcvetcodeRemoved2Chars = product.atcvetCodes?.map((c: string) => c.slice(0, -2)).join(', ') || ''

    const translateAndJoin = (items: string[]) => {
      if (!items || !items.length) return ''
      return items.map(i => t(i)).join(', ')
    }

    const translateAdmissionSpeciesWithOr = (species: string[]) => {
      if (!species || !species.length) return ''
      return species.map(i => t(i)).join(` ${t('or')} `)
    }

    const species = translateAndJoin(product.admissionSpecies)
    const speciesMin1 = translateAdmissionSpeciesWithOr(product.admissionSpecies)
    const dosageForms = translateAndJoin(product.dosageForms)

    const params = {
      atcvetcode,
      atcvetcodeRemoved2Chars,
      species,
      speciesMin1,
      dosageForms,
    }

    return t(`enum.productAlternatives.${matchingCriteria}`, params)
  }

  const getMatchingCriteriaData = (matchingCriteria: string, product: ProductForAlternatives | null): MatchingCriteriaTranslation | null => {
    if (!product) return null

    return {
      key: `enum.productAlternatives.${matchingCriteria}`,
      params: {
        atcvetcode: product.atcvetCodes || [],
        atcvetcodeRemoved2Chars: product.atcvetCodes?.map((c: string) => c.slice(0, -2)) || [],
        species: product.admissionSpecies || [],
        speciesMin1: product.admissionSpecies || [],
        dosageForms: product.dosageForms || [],
      },
    }
  }

  return {
    getMatchingCriteriaTranslation,
    getMatchingCriteriaData,
  }
}
